<template>
  <div
    class="reletive"
    :class="{ 'full-display': isTierFullDisplay }"
    v-if="isTierFullDisplay"
  >
    <div
      class="range-avg start"
      id="range-start"
      :data-avg="0"
      v-if="
        profile.expired_date ||
        memberLevel.upgrade_tier_id != 0 ||
        memberLevel.maintain_baht != 0
      "
    ></div>

    <v-progress-linear
      rounded
      :color="barColor()"
      v-if="
        profile.expired_date ||
        memberLevel.upgrade_tier_id != 0 ||
        memberLevel.maintain_baht != 0
      "
      class="mb-1"
      height="20px"
      :model-value="profile.total_spend"
      :max="maxValueProgress"
      style="border: 1px solid #80808059"
    >
    </v-progress-linear>
    <v-tooltip open-on-click location="top">
      <template v-slot:activator="{ props }">
        <div
          v-bind="props"
          class="range-avg maintain"
          id="range-maintain"
          :data-avg="memberLevel.maintain_baht"
          v-if="memberLevel.maintain_baht != 0"
        ></div>
      </template>
      <div class="content-between">
        <div>
          <span :data-lang="'maintain'">
            <span data-lang="keep_current">
              {{ $t("keep_current") }}&nbsp;
            </span>
            <span class="f-bold">
              {{ memberLevel.member_level_language[0].display || "tier" }}&nbsp;
            </span>
          </span>
        </div>
        <div class="text-danger f-bold">
          {{ maintain(memberLevel.maintain_baht) }}
          <span data-lang="upgrade_unit">
            {{ $t("upgrade_unit") }}
          </span>
        </div>
      </div>
    </v-tooltip>

    <!-- <template v-if="memberLevel.upgrade_tier_id != 0"> -->
    <template v-for="level of memberList" :key="level.name">
      <template
        v-if="
          level.id == $store.state.shortProfile.member_level_id &&
          (memberLevel.upgrade_tier_id == 0 ||
            profile.total_spend > level.upgrade_baht)
        "
      >
        <template
          v-for="step of level.member_level_multistep_downgrade"
          :key="step.id"
        >
          <v-tooltip open-on-click location="top">
            <template v-slot:activator="{ props }">
              <div
                v-bind="props"
                class="range-avg maintain"
                :id="'range-maintain-' + step.id"
                :data-avg="step.maintain_baht"
                :style="{
                  left: `calc(${
                    Number((step.maintain_baht * 100) / maxValueProgress) >= 100
                      ? 98
                      : Number((step.maintain_baht * 100) / maxValueProgress)
                  }% - 13px)`
                }"
              ></div>
            </template>
            <div class="content-between">
              <div>
                <span :data-lang="'maintain'">
                  <span data-lang="keep_current">
                    {{ $t("keep_current") }}&nbsp;
                  </span>
                  <span class="f-bold">
                    {{ step.maintain_disply_name || step.display_name }}&nbsp;
                  </span>
                </span>
              </div>
              <div class="text-white f-bold">
                {{ maintain(step.maintain_baht) }}
                <span data-lang="upgrade_unit">
                  {{ $t("upgrade_unit") }}
                </span>
              </div>
            </div>
          </v-tooltip>
        </template>
      </template>

      <template v-if="memberLevel.upgrade_tier_id != 0">
        <v-tooltip open-on-click location="top">
          <template v-slot:activator="{ props }">
            <div
              v-bind="props"
              class="range-avg upgrade"
              :id="'range-upgrade-' + level.name"
              :data-avg="level.upgrade_baht"
              v-if="level.upgrade_tier_id != 0"
            ></div>
          </template>

          <div class="content-between" v-if="level.upgrade_baht">
            <div>
              <span data-lang="more_spending"> {{ $t("more_spending") }} </span>
              <span :data-lang="'to_upgrade'">
                <span data-lang="to_upgrade">
                  {{ $t("to_upgrade") }}&nbsp;
                </span>
                <span class="f-bold">
                  {{
                    getDisplayName(level.upgrade_tier_id) || $t("next_tier")
                  }}&nbsp;
                </span>
              </span>
            </div>
            <div class="text-white f-bold">
              {{ maintain(level.upgrade_baht) }}
              <span data-lang="upgrade_unit">
                {{ $t("upgrade_unit") }}
              </span>
            </div>
          </div>
          <div class="content-between" v-if="level.upgrade_tier_id == 0">
            <div>
              <span :data-lang="'maintain'">
                <span data-lang="keep_current">
                  {{ $t("keep_current") }}&nbsp;
                </span>
                <span class="f-bold">
                  {{ level.member_level_language[0].display }}&nbsp;
                </span>
              </span>
            </div>
            <div class="text-white f-bold">
              {{ numeralFormat(level.maintain_baht) }}
              <span data-lang="upgrade_unit">
                {{ $t("upgrade_unit") }}
              </span>
            </div>
          </div>
        </v-tooltip>
      </template>
    </template>
    <!-- </template> -->
  </div>
  <div class="reletive" v-else-if="isTierUpgradeTier">
    <div class="range-avg start" id="range-start" :data-avg="0"></div>

    <v-progress-linear
      rounded
      :color="barColor()"
      v-if="
        profile.expired_date ||
        memberLevel.upgrade_tier_id != 0 ||
        memberLevel.maintain_baht != 0
      "
      class="mb-1"
      height="20px"
      :model-value="profile.total_spend"
      :max="maxValueProgress"
      style="border: 1px solid #80808059"
    >
    </v-progress-linear>

    <div
      class="range-avg maintain"
      id="range-maintain"
      :data-avg="memberLevel.maintain_baht"
      v-if="
        memberLevel.maintain_baht != 0 && memberLevel.downgrade_tier_id != 0
      "
    ></div>

    <template v-for="level of memberList" :key="level.name">
      <div
        class="range-avg upgrade"
        :id="'range-upgrade-' + level.name"
        :data-avg="level.upgrade_baht"
        v-if="
          level.upgrade_tier_id != 0 &&
          level.upgrade_tier_id != $store.state.shortProfile.member_level_id
        "
      ></div
    ></template>
  </div>
  <div class="reletive" v-else>
    <div
      class="range-avg start"
      id="range-start"
      :data-avg="0"
      v-if="
        profile.expired_date ||
        memberLevel.upgrade_tier_id != 0 ||
        memberLevel.maintain_baht != 0
      "
    ></div>
    <v-progress-linear
      rounded
      :color="barColor()"
      v-if="
        profile.expired_date ||
        memberLevel.upgrade_tier_id != 0 ||
        memberLevel.maintain_baht != 0
      "
      class="mb-1"
      height="20px"
      :model-value="profile.total_spend"
      :max="maxValueProgress"
      style="border: 1px solid #80808059"
    >
    </v-progress-linear>

    <div
      class="range-avg maintain"
      id="range-maintain"
      :data-avg="memberLevel.maintain_baht"
      v-if="memberLevel.maintain_baht > 0"
    ></div>

    <div
      class="range-avg upgrade"
      id="range-upgrade"
      :data-avg="memberLevel.upgrade_baht"
      v-if="memberLevel.upgrade_baht > 0"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    memberLevel: {
      required: true
    }
  },
  data() {
    return {
      profile: this.$store.state.shortProfile,
      memberList: this.$store.state.shortProfile.member_list
    };
  },

  computed: {
    progressValue() {
      return this.numeralFormat(this.profile.total_point);
    },
    maxValueProgress() {
      let memberList = this.$store.state.shortProfile.member_list;

      if (this.isTierUpgradeTier)
        return this.memberLevel.upgrade_baht == 0
          ? this.memberLevel.maintain_baht
          : memberList[memberList.length - 2].upgrade_baht;
      else if (this.isTierFullDisplay) {
        const max = Math.max(...memberList.map(tier => tier.upgrade_baht));

        return max;
      } else
        return this.memberLevel.upgrade_baht == 0
          ? this.memberLevel.maintain_baht
          : this.memberLevel.upgrade_baht;
    }
  },
  created() {
    function getUpgradeTiers(tiers, currentTier) {
      const result = [];
      const visited = new Set();

      let tier = tiers.find(t => t.id === currentTier);

      if (!tier) {
        console.warn(`No tier found for currentTier ID: ${currentTier}`);
        return [];
      }

      while (tier) {
        if (visited.has(tier.id)) {
          console.warn(
            `Cycle detected at Tier ID: ${tier.id}, stopping to prevent infinite loop.`
          );
          break;
        }

        visited.add(tier.id);
        result.push(tier);

        if (tier.upgrade_tier_id === 0 || tier.upgrade_tier_id === tier.id) {
          break;
        }

        tier = tiers.find(t => t.id === tier.upgrade_tier_id);

        if (!tier) {
          break;
        }
      }

      return result;
    }

    if (!this.isTierFullDisplay)
      this.memberList = getUpgradeTiers(this.memberList, this.memberLevel?.id);

    this.$nextTick();
  },
  mounted() {
    const rangeMaintain = document.getElementById("range-maintain");
    var max = this.maxValueProgress;
    if (rangeMaintain) {
      const avgValue = rangeMaintain.dataset.avg;

      let avgPosition = Number((avgValue * 100) / max);
      avgPosition =
        avgPosition < 1
          ? "13px"
          : `calc(${avgPosition >= 100 ? 98 : avgPosition}% - 13px)`;
      rangeMaintain.style.left = avgPosition;
      this.$nextTick();
    }
    if (this.isTierUpgradeTier || this.isTierFullDisplay) {
      for (const level of this.$store.state.shortProfile.member_list) {
        const pointUpgrade = document.getElementById(
          "range-upgrade-" + level.name
        );

        if (pointUpgrade) {
          const avgValue = pointUpgrade.dataset.avg;

          let avgPosition = Number((avgValue * 100) / max);

          pointUpgrade.style.left = `calc(${
            avgPosition >= 100 ? 98 : avgPosition
          }% - 13px)`;
        }
      }
    } else {
      const pointUpgrade = document.getElementById("range-upgrade");
      if (pointUpgrade) {
        const avgValue = pointUpgrade.dataset.avg;

        let avgPosition = Number((avgValue * 100) / max);

        pointUpgrade.style.left = `calc(${
          avgPosition >= 100 ? 98 : avgPosition
        }% - 13px)`;
      }
    }
  },
  methods: {
    barColor() {
      if (this.isTierFullDisplay) return "full-display-bar-color";
      if (this.memberLevel.upgrade_baht == 0) return "maintain-color";
      if (this.progressValue <= this.memberLevel.maintain_baht)
        return "maintain-color";
      return this.progressValue <= this.maxValueProgress
        ? "maintain-color"
        : "upgrade-color";
    },
    getDisplayName(id) {
      if (id == 0) return;
      return this.$store.state.shortProfile.member_list.find(a => a.id == id)
        .member_level_language[0].display;
    },
    maintain(tier) {
      if (tier < this.profile.total_spend) {
        return "-";
      }
      return this.numeralFormat(tier - this.profile.total_spend);
      // return this.$store.state.shortProfile.member_list.find(
      //   a => a.id == this.memberLevel.downgrade_tier_id
      // );
    }
  }
};
</script>

<style lang="scss">
.bg-start-color {
  background: rgb(219, 219, 219);
}
.bg-upgrade-color {
  background: rgb(42, 190, 168);
}
.bg-maintain-color {
  background: rgb(250, 171, 50);
}
.bg-full-display-bar-color {
  background: var(--tier-bar-color) !important;
}

.range-avg {
  z-index: 1;
  -webkit-appearance: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(0, -50%);
  height: 13px;
  width: 13px;

  z-index: 1;
  appearance: none;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 50%;
  transform: translate(0, -50%);
  border: 3px solid white;
  &.maintain {
    background: rgb(250, 171, 50);
  }
  &.upgrade {
    background: rgb(42, 190, 168);
  }
  &.start {
    background: rgb(219, 219, 219);
    left: 1.5%;
  }
  .full-display & {
    &.start {
      background: var(--tier-upgrade-point); // สีใหม่สำหรับ full-display
    }
    &.maintain {
      background: var(--tier-maintain-point);
    }
    &.upgrade {
      background: var(--tier-upgrade-point);
    }
  }
}
</style>
